import React, { useState } from "react";
import "../styles/ClientProjects.css";

const projects = [
    {
        id: 1,
        title: "Makkal Sinthanai Peravai",
        description:
            "A cross-platform shopping app with product catalog, cart, and payment integration.",
        images: [
            "/assets/makkal/1.png",
            "/assets/makkal/2.png",
            "/assets/makkal/3.png",
            "/assets/makkal/4.png"
        ],
        appLink: "https://play.google.com/store/apps/details?id=com.sinthanai.peravai",
        websiteLink: "",
        socialLink: ""
    },
    {
        id: 2,
        title: "Dr. Dhanraj MCA, M.Phil, Ph.D",
        description:
            "Dedicated educator and researcher committed to enhancing students' performance through innovative teaching methodologies and cutting-edge computer science applications.",
        images: [
            "/assets/clientsimg/dn.png"
        ],
        appLink: "",
        websiteLink: "https://drdhanraj.vercel.app/",
        socialLink: ""
    },
    {
        id: 3,
        title: "MPON Gold",
        description:
            "Discover the purity and elegance of our fine gold collections. Whether you're looking for investment opportunities or timeless jewelry, we provide trusted and certified gold for every purpose.",
        images: [
            "/assets/clientsimg/mpon.png"
        ],
        appLink: "",
        websiteLink: "https://mpon-gold.vercel.app/",
        socialLink: ""
    },
    {
        id: 4,
        title: "Green Play Turf",
        description:
            "Where Passion Meets the Perfect Turf “Play Hard. Play Smart. Play Here.”",
        images: [
            "/assets/clientsimg/turf.png"
        ],
        appLink: "",
        websiteLink: "https://turf-nu.vercel.app/",
        socialLink: ""
    },
    {
        id: 5,
        title: "Fit Believe",
        description:
            "Push your limits, break barriers, and transform yourself every single day. Our expert trainers and state-of-the-art equipment are here to guide your journey.",
        images: [
            "/assets/clientsimg/gym.png"
        ],
        appLink: "",
        websiteLink: "https://gym-ten-mu.vercel.app/",
        socialLink: ""
    },
    {
        id: 6,
        title: "RM Rishi Gold",
        description:
            "Since 1985, we've been providing the finest quality gold jewelry with complete transparency and customer satisfaction.",
        images: [
            "/assets/clientsimg/rmgold.png"
        ],
        appLink: "",
        websiteLink: "https://rm-rishi-gold.vercel.app/",
        socialLink: ""
    },
    {
        id: 7,
        title: "Makkal Sinthani Peravai",
        description:
            "மக்கள் சிந்தனைப் பேரவை (Makkal Sinthanai Peravai) என்பது தமிழகத்தில், குறிப்பாக ஈரோட்டில் செயல்படும் ஒரு சமூக அமைப்பு.",
        images: [
            "/assets/mspweb/1.png"
        ],
        appLink: "",
        websiteLink: "https://rm-rishi-gold.vercel.app/",
        socialLink: ""
    },
    {
        id: 8,
        title: "Erode Book Festival",
        description:
            "The Book fair organized in the South Indian city of Erode, Tamil Nadu. It is organised by a social organisation named Makkal Sindhanai Peravai.",
        images: [
            "/assets/ebfweb/1.png"
        ],
        appLink: "",
        websiteLink: "https://rm-rishi-gold.vercel.app/",
        socialLink: ""
    },
    {
        id: 9,
        title: "T Stalin Gunasekaran",
        description:
            "தமிழக பேச்சாளார், எழுத்தாளர்; ஈரோடு மக்கள் சிந்தனைப் பேரவையின் தலைவர்",
        images: [
            "/assets/tsgweb/1.png"
        ],
        appLink: "",
        websiteLink: "https://rm-rishi-gold.vercel.app/",
        socialLink: ""
    },
    {
        id: 10,
        title: "Fresh Fruits",
        description:
            "We’re more than just a fruit store—we’re a brand committed to promoting wellness",
        images: [
            "/assets/clientsimg/fruit.png"
        ],
        appLink: "",
        websiteLink: "https://fresh-fruits-seven-sigma.vercel.app/",
        socialLink: ""
    },
    {
        id: 11,
        title: "Interiors",
        description:
            "Transform Your Space Into Art, Premium interior design services tailored to your vision",
        images: [
            "/assets/clientsimg/int.png"
        ],
        appLink: "",
        websiteLink: "https://interiors-xi.vercel.app/",
        socialLink: ""
    },
    {
        id: 12,
        title: "Tariga",
        description:
            "Relax, Refresh, Renew - The Herbal Way",
        images: [
            "/assets/clientsimg/tar.jpeg"
        ],
        appLink: "",
        websiteLink: "",
        socialLink: "https://www.instagram.com/tharigaherbalsanitarynapkins/"
    },
    {
        id: 13,
        title: "KR Power",
        description:
            "Strength that supports every structure",
        images: [
            "/assets/clientsimg/kr.jpeg"
        ],
        appLink: "",
        websiteLink: "",
        socialLink: "https://www.instagram.com/krcabletray/"
    },
    {
        id: 14,
        title: "Fly Birds",
        description:
            "From Sunrise to Sunset",
        images: [
            "/assets/clientsimg/fly.jpeg"
        ],
        appLink: "",
        websiteLink: "",
        socialLink: "https://www.instagram.com/flybirds.official/"
    }
];

const ClientProjects = () => {
    const [filter, setFilter] = useState("all");

    const filteredProjects = projects.filter((project) => {
        if (filter === "all") return true;
        if (filter === "website") return project.websiteLink;
        if (filter === "app") return project.appLink;
        if (filter === "social") return project.socialLink;
        return true;
    });

    return (
        <section className="projects-section">
            <div className="projects-container">
                <h2 className="projects-heading">Client Projects</h2>
                <p className="projects-subtitle">
                    A selection of applications, websites, and creative works delivered for clients.
                </p>

                {/* 🔹 FILTER BUTTONS */}
                <div className="projects-filters">
                    <button
                        className={filter === "all" ? "active" : ""}
                        onClick={() => setFilter("all")}
                    >
                        All
                    </button>

                    <button
                        className={filter === "website" ? "active" : ""}
                        onClick={() => setFilter("website")}
                    >
                        Websites
                    </button>

                    <button
                        className={filter === "app" ? "active" : ""}
                        onClick={() => setFilter("app")}
                    >
                        Apps
                    </button>

                    <button
                        className={filter === "social" ? "active" : ""}
                        onClick={() => setFilter("social")}
                    >
                        Social
                    </button>
                </div>

                {/* 🔹 PROJECT GRID */}
                <div className="projects-grid">
                    {filteredProjects.map((project) => (
                        <div className="project-card" key={project.id}>
                            <div className="project-images">
                                {project.images.map((img, index) => (
                                    <img
                                        key={index}
                                        src={img}
                                        alt={`${project.title} preview ${index + 1}`}
                                    />
                                ))}
                            </div>

                            <div className="project-content">
                                <h3 className="project-title">{project.title}</h3>
                                <p className="project-description">{project.description}</p>

                                <div className="project-links">
                                    {project.appLink && (
                                        <a href={project.appLink} target="_blank" rel="noreferrer">
                                            View App
                                        </a>
                                    )}

                                    {project.websiteLink && (
                                        <a href={project.websiteLink} target="_blank" rel="noreferrer">
                                            Visit Website
                                        </a>
                                    )}

                                    {project.socialLink && (
                                        <a href={project.socialLink} target="_blank" rel="noreferrer">
                                            View on Social Media
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}

                    {filteredProjects.length === 0 && (
                        <p className="no-projects">No projects found.</p>
                    )}
                </div>
            </div>
        </section>
    );
};

export default ClientProjects;
